export const GET_DEALERS_REQUEST = 'GET_DEALERS_REQUEST';
export const GET_DEALERS_SUCCESS = 'GET_DEALERS_SUCCESS';
export const GET_DEALERS_FAILURE = 'GET_DEALERS_FAILURE';

export const getDealersRequest = (filters = {}) => ({
    type: GET_DEALERS_REQUEST,
    payload: {
        filters
    }
});

export const getDealersSuccess = (dealers) => ({
    type: GET_DEALERS_SUCCESS,
    payload: {
        dealers
    }
});

export const getDealersFailure = (err) => ({
    type: GET_DEALERS_FAILURE,
    error: err
});
